import { Loading } from '@fasstech/middle-design-system';
import SouscriptionPaymentRefundForm from './SouscriptionPaymentRefundForm.jsx';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData';
import { compose } from 'ramda';
import useGetSouscriptionPaymentRefundQuery from './hooks/useGetSouscriptionPaymentRefundQuery';

const SouscriptionPaymentRefund = ({
  getMiddleText,
  getMiddleBoolean,
  middleFeatures,
  phoneIndicatives
}) => {
  const { getSouscriptionPaymentRefund, loading: isFetchingGetInformations } =
    useGetSouscriptionPaymentRefundQuery();

  if (isFetchingGetInformations) return <Loading />;
  return (
    <SouscriptionPaymentRefundForm
      project={getSouscriptionPaymentRefund}
      getMiddleText={getMiddleText}
      middleFeatures={middleFeatures}
      getMiddleBoolean={getMiddleBoolean}
      phoneIndicatives={phoneIndicatives}
    />
  );
};

export default compose(
  withMiddleFeatures,
  withGlobalData
)(SouscriptionPaymentRefund);
